import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import type { IInfiniteStaffParams, IInfiniteStaffResponse } from "./types";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";

const { key, getPath } = getApi("infinite.getAllStaffs");

type IResponse = IWithInfinite<IInfiniteStaffResponse>;
type IVariables = IInfiniteStaffParams;

const getAllInfiniteStaffs = async (
  props: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath(), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfiniteStaffs = createInfiniteQuery<
  IResponse,
  IVariables
>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllInfiniteStaffs({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
